import { ArrowDownIcon, ArrowUpIcon, PlusIcon, XIcon } from 'lucide-react';
import { Panel } from '../ui/Panel';
import { MediaField } from '../ui/MediaField';
import { undoToast } from '../ui/undoToast';
import { btnIcon } from '../ui/styles';
import { move } from '../editing';
import { PRODUCT_MEDIA_MAX, emptyMedia } from '../../core/rules/media';
import type { Media } from '../../core/types/media';
type Props = {
  value: Media[];
  onChange: (value: Media[] | undefined) => void;
};

/**
 * Extra beelden voor de productpagina, ná de packshot: textuur, het product in gebruik, een korte
 * video. De packshot zelf blijft het paneel "Productfoto" (die staat ook in de mand en in Google).
 */
export function ProductMediaPanel({
  value,
  onChange
}: Props) {
  // Leeg = veld weg, zodat de opslag gelijk blijft aan vóór de galerij.
  const commit = (next: Media[]) => onChange(next.length ? next : undefined);
  const set = (i: number, m: Media) => commit(value.map((v, j) => j === i ? m : v));
  const remove = (i: number) => {
    const before = value;
    commit(value.filter((_, j) => j !== i));
    undoToast('Beeld verwijderd', () => onChange(before));
  };
  return <Panel title="Galerij" description={`Na de packshot op de productpagina, hoogstens ${PRODUCT_MEDIA_MAX}. Textuur, het product in gebruik, of een korte, stille video.`} data-id="element-745" data-mp="i9twm9vc5euy">
      {value.length === 0 && <p className="text-[14px] text-muted" data-id="element-746" data-mp="8ih37dtw2gmt">Nog geen extra beelden. De productpagina toont dan de packshot en je salonfoto.</p>}
      <ol className="space-y-4" data-id="element-747" data-mp="3uribplg7qpm3">
        {value.map((m, i) => {
        const name = `Beeld ${i + 1} van ${value.length}`;
        return <li key={i} className="relative" data-id="element-748" data-mp="3gtjyijdmoz86" data-mpi={i}>
              <MediaField label={name} value={m} onChange={next => set(i, next)} emptyNote="Leeg: dit beeld wordt overgeslagen." data-id="element-749" data-mp="3lr2728nqhcfn" />
              <span className="absolute right-0 top-0 flex items-center" data-id="element-750" data-mp="1f1nnrbzabteg">
                <button type="button" onClick={() => commit(move(value, i, i - 1))} disabled={i === 0} aria-label={`${name} omhoog`} className={btnIcon} data-id="element-751" data-mp="1jzgwabo28zhw">
                  <ArrowUpIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-752" data-mp="1ijuyaphsdi22" />
                </button>
                <button type="button" onClick={() => commit(move(value, i, i + 1))} disabled={i === value.length - 1} aria-label={`${name} omlaag`} className={btnIcon} data-id="element-753" data-mp="1dltcvxww16nf">
                  <ArrowDownIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-754" data-mp="13mu50hjy5f1h" />
                </button>
                <button type="button" onClick={() => remove(i)} aria-label={`${name} verwijderen`} className={btnIcon} data-id="element-755" data-mp="21b44aoscloow">
                  <XIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-756" data-mp="1rj84n9am5qik" />
                </button>
              </span>
            </li>;
      })}
      </ol>
      {value.length < PRODUCT_MEDIA_MAX && <button type="button" onClick={() => commit([...value, emptyMedia()])} className="mt-3 inline-flex items-center gap-1.5 rounded-md px-2 py-2.5 text-[14px] text-clay transition-colors duration-150 ease-soft hover:bg-sand sm:py-1.5 sm:text-[13px]" data-id="element-757" data-mp="2jzsnn6b6nlyk">
          <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-758" data-mp="2riii7rpc5cdt" />
          Beeld toevoegen
        </button>}
    </Panel>;
}